export const selectEvents = (state) => state.events.all || [];
export const selectCurrentEvent = (state) => state.events?.current || null;
export const selectIsLoading = (state) => state.events.isLoading;
export const selectLastEvent = (state) => state.events.last || null;
export const selectEventCount = (state) => state.events.count || 0;
